<template>
  <div class="onls-line"></div>
</template>

<style lang="scss">
.onls-line {
  background: var(--primary-text);
  margin: 50px 0;
  width: 100%;
  height: 2px;

  @media screen and (max-width: 768px) {
    margin: 20px 0;
  }
}
</style>
